export enum DataColumnType {
  TEXT = 'text',
  DATE = 'date',
  MONEY = 'money',
  CHECK = 'check',
  NUMBER = 'number',
  PERCENT = 'percent',
  CUSTOM = 'custom',
  ESTADO_TAG = 'estado_Tag',
  TAG = 'tag',
  NONE = 'none',
}

export enum ButtonColumnType {
  EDIT = 'edit',
  DELETE = 'delete',
  EXPANDED = 'expanded',
  CUSTOM = 'custom',
  CHECK = 'check',
  TEXT = 'text'
}

export type Severity = 'primary' | 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast';
export type cssClass = string | string[] | { [key: string]: string } | null;

export interface IBaseColumn {
  field: string;
  format?:string;
  header: string;
  sort?: boolean;
  columnFilter?: boolean;
  width?: string;
  //Trunca el texto, en los botones solo muestra los primeros 20 caracteres
  truncate?: boolean;
  class?: cssClass;
  style?: { [key: string]: string } | null;
  getStyle?: (data: any) => { [key: string]: string } | null; //esto se usa para el tag
  optional?: boolean;
  headerTooltip?: ITooltipSettings;
  headerBtn?: {
    label?: string;
    icon?: string;
    severity?: Severity;
    class?: cssClass;
    outlined?: boolean;
    disabled?: boolean;
    getDisabled?: () => boolean;
    onClick: (event: Event) => void;
  },
  columnmHeader?: {
    class?: cssClass;
    style?: { [key: string]: string } | null;
  }
}

export interface IVisible {
  property: string;
  value: any;
}

export interface IDataColumn extends IBaseColumn {
  dataType: DataColumnType;
  format?: string; //solo se usa en el CUSTOM
}

export interface IFooterColums {
  dataType: DataColumnType;
  class?: cssClass;
  getValue?: () => any;
}

export interface IButtonColumn<T> extends IBaseColumn {
  buttonType: ButtonColumnType;
  label?: string;
  icon?: string;
  disabled?: boolean;
  visible?: IVisible;
  tooltip?: ITooltipSettings;
  severity?: Severity;
  getDisabled?: (data: T) => boolean;
  getSeverity?: (data: T) => Severity;
  onClick: (event: Event, data: T, fieldName?:string) => void;
}

export interface ICustomButton {
  label?: string;
  icon?: string;
  severity?: Severity;
  class?: string | string[] | {
    [key: string]: string;
  } | null;
  onClick: (event: Event) => void;
}

export interface ISettings {
  table: {
    rows?: number;
    lazy?: boolean;
    scrollable?:boolean;
    paginator?: boolean;
    tableStyle?: { [key: string]: any } | null;
    scrollHeight?:string;
  }
  columnToggle: {
    showColumnToggle: boolean;
    maxSelectedLabels?: number;
  },
  groupRows:{
    by: string;
    getHeaderValue?: (data: any) => any;
  }

}

export interface ITooltipSettings {
  message: string;
  disabled?: boolean;
}

export interface IDropdownSelect {
  label: string,
  data?: any[];
  disabled?: boolean;
  BtnLabel?: string;
  tooltip?: ITooltipSettings;
  onBtnClick: (event: Event, data: any) => void;
}

export interface IHeader {
  title?: string;
  class?:cssClass;
  disabled?: boolean;
  tooltip?: ITooltipSettings;
  customBtn1?: ICustomButton;
  onCreate?: () => void;
}

export interface ICustomTable<T = any> {
  dataKey?: string;
  data: any[];
  caption?:{
    globalFilter?: {
      FilterFields?: string[];
      placeholder?: string;
    }
  }
  header?: IHeader;
  columns: (IDataColumn | IButtonColumn<T>)[];
  settings?: ISettings;
  footer?: IFooterColums[];
}
